<template>
  <div class="ts-space-y-3">
    <div class="row">
      <div class="col-md-6">
        <div class="row">
          <label class="col-form-label col-md-3 required ts-text-right">{{
            $t('expensePosting.date')
          }}</label>
          <div class="col-md-7">
            <a-date-picker v-model="model.exp_date" format="DD-MM-YYYY" valueFormat="DD-MM-YYYY" class="ts-w-full"
              :allowClear="false"></a-date-picker>
            <div class="validate" v-if="errors.has('exp_date')">
              {{ errors.first('exp_date') }}
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="row">
          <label class="col-form-label col-md-3 required ts-text-right">
            {{ $t('expensePosting.expenseType') }}
          </label>
          <div class="col-md-7">
            <a-select v-model="model.expense_type" :options="expenseTypes" option-filter-prop="children"
              class="ts-w-full" :class="{ 'is-invalid': errors.has('expense_type') }" placeholder="Select"
              @change="onChangeExpenseType"></a-select>
            <div class="validate" v-if="errors.has('expense_type')">
              {{ errors.first('expense_type') }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6 ts-space-y-3">
        <div class="row" v-if="model.expense_type == 2">
          <label class="col-form-label col-md-3 required ts-text-right">{{
            $t('expensePosting.cashAdvance')
          }}</label>
          <div class="col-md-7">
            <a-select v-model="model.advance_id" :options="cashAdvances" show-search option-filter-prop="children"
              class="ts-w-full" :class="{ 'is-invalid': errors.has('advance_id') }" placeholder="Select"></a-select>
            <div class="validate" v-if="errors.has('advance_id')">
              {{ errors.first('advance_id') }}
            </div>
          </div>
        </div>
        <div class="row">
          <label class="col-form-label col-md-3 ts-text-right">{{
            $t('expensePosting.remarks')
          }}</label>
          <div class="col-md-7">
            <div>
              <textarea v-model="model.remarks" rows="3" class="form-control"
                placeholder="Note something here"></textarea>
            </div>
          </div>
        </div>

        <div class="row">
          <label class="col-form-label col-md-3 ts-text-right">{{
            $t('expensePosting.documentAttached')
          }}</label>
          <div class="col-md-7">
            <div class="ts-w-full ts-border ts-rounded-md ts-relative">
              <DocumentAttached v-model="model" :validate="errors" />
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6 ts-space-y-3">
        <div class="row">
          <label class="col-form-label col-md-3 ts-text-right" :class="model.expense_type != 0 ? 'required' : ''">
            {{ getLabelByExpenseType() }}
          </label>
          <div class="col-md-7">
            <a-select v-model="model.reimburse_by" :options="employees" show-search option-filter-prop="children"
              class="ts-w-full" :class="{ 'is-invalid': errors.has('reimburse_by') }" placeholder="Select"></a-select>
            <div class="validate" v-if="errors.has('reimburse_by')">
              {{ errors.first('reimburse_by') }}
            </div>
          </div>
        </div>
        <div class="row">
          <label class="col-form-label col-md-3 ts-text-right">{{
            $t('expensePosting.payment')
          }}</label>
          <div class="col-md-7">
            <div class="ts-border ts-border-gray-300 ts-rounded-md ts-space-y-2 ts-p-3">
              <div class="row">
                <div class="col-md-6">
                  <label class="ts-mb-0 required">
                    {{ $t('expensePosting.paymentMethod') }}
                  </label>
                  <a-select v-model.number="model.payment_method_id" @change="onPaymentMethodChange"
                    :options="paymentMethods" class="ts-w-full">
                  </a-select>
                  <div class="validate" v-if="errors.has('payment_method_id')">
                    {{ errors.first('payment_method_id') }}
                  </div>
                </div>
                <div class="col-md-6">
                  <label class="ts-mb-0" :class="model.payment_method_id != 1 ? 'required' : ''">
                    {{ $t('expensePosting.bankName') }}
                  </label>
                  <a-select :disabled="model.payment_method_id == 1" v-model.number="model.bank_name"
                    :options="bankProfiles" @change="bankNameChange" class="ts-w-full"
                    :placeholder="$t('expensePosting.bankName')"></a-select>
                  <div class="validate" v-if="errors.has('bank_name')">
                    {{ errors.first('bank_name') }}
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <label class="ts-mb-0" :class="model.payment_method_id != 1 ? 'required' : ''">
                    {{ $t('expensePosting.accountName') }}
                  </label>
                  <input v-model="model.account_name" type="text" :disabled="model.payment_method_id == 1"
                    :placeholder="$t('expensePosting.accountName')" class="form-control" style="height: 32px;"
                    :class="{ 'is-invalid': errors.has('exp_cat_code') }" />
                </div>
                <div class="col-md-6">
                  <label class="ts-mb-0" :class="model.payment_method_id != 1 ? 'required' : ''">
                    {{ $t('expensePosting.accountNumber') }}
                  </label>
                  <input v-model="model.account_number" type="text" :disabled="model.payment_method_id == 1"
                    :placeholder="$t('expensePosting.accountNumber')" class="form-control" style="height: 32px;"
                    :class="{ 'is-invalid': errors.has('exp_cat_code') }" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import httpClient from '@/http-client'
import { Errors } from 'form-backend-validation'
import { mapActions, mapState } from 'vuex'
import DocumentAttached from './document_attached.vue'

export default {
  name: 'basicInfo',
  props: ['value', 'validate'],
  components: {
    DocumentAttached
  },
  data() {
    return {
      errors: new Errors(),
      model: {}
    }
  },
  created() {
    this.model = this.value
  },
  computed: {
    ...mapState('expense/expensePosting', ['formViewDatas']),
    cashAdvances() {
      if (this.formViewDatas['cashAdvances']) {
        return this.formViewDatas['cashAdvances'].map(el => ({
          value: el.advance_id,
          label: el.advance_no + ' | ' + el.purpose
        }))
      }
      return []
    },
    employees() {
      if (this.formViewDatas['employees']) {
        return this.formViewDatas['employees'].map(el => ({
          value: el.employee_id,
          label: el.employee_name_en + '|' + el.employee_name_kh,
          user_id: el.user_id
        }))
      }
      return []
    },
    paymentMethods() {
      if (this.formViewDatas['paymentMethods']) {
        return this.formViewDatas['paymentMethods'].map(el => ({
          value: el.payment_method_id,
          label: el.payment_method
        }))
      }
      return []
    },
    bankProfiles() {
      if (this.formViewDatas['bankProfiles']) {
        return this.formViewDatas['bankProfiles'].map(el => ({
          value: el.bank_name,
          label: el.bank_name
        }))
      }
      return []
    },
    expenseTypes() {
      return [
        {
          label: 'General',
          value: 0
        },
        {
          label: 'Personal Cash',
          value: 1
        },
        {
          label: 'Cash Advance',
          value: 2
        }
      ]
    },
    expenseStatus() {
      return [
        {
          label: 'Pending',
          value: 1
        },
        {
          label: 'Paid',
          value: 2
        }
      ]
    },
  },
  methods: {
    ...mapActions('expense/expensePosting', ['getFormViewModel']),
    getLabelByExpenseType() {
      switch (this.model.expense_type) {
        case 0:
          return this.$t('expensePosting.approvedBy');
        case 1:
          return this.$t('expensePosting.claimedBy');
        case 2:
          return this.$t('expensePosting.reimburseBy');
        default:
          return this.$t('expensePosting.appr/clmd/reimbBy');
      }
    },
    async onUploadDocumentAttached() {
      const filesToUpload = this.model.document_attacheds.filter(
        file => !file.file_path
      )

      const uploadPromises = filesToUpload.map(async (f, index) => {
        if (!this.validateFile(f.file)) {
          return new Promise((resolve, reject) => {
            let frm = new FormData()
            frm.append('file', f.file)

            httpClient
              .post('/api/v1/expense-postings/document-attacheds', frm, {
                onUploadProgress: el => {
                  if (el.lengthComputable) {
                    f.progressing = Math.round((el.loaded * 100) / el.total)
                  }
                }
              })
              .then(response => {
                f.file_path = response.data
                // f.uploaded = true
                resolve(`File ${index + 1} uploaded successfully`)
              })
              .catch(error => {
                this.$toasted.error(error.message)
                this.errors = new Errors(error.errors)
              })
          })
        } else {
          return Promise.resolve() // Resolve immediately for files that don't need to be uploaded
        }
      })

      try {
        await Promise.all(uploadPromises)
        // console.log("All files uploaded successfully");
      } catch (error) {
        this.errors = new Errors(error.errors)
        this.$toasted.error(error.message)
        // console.error("Error during file upload:", error);
        throw error
      }
    },
    validateFile(file) {
      let ALLOW_FILE = ['image/png', 'image/jpeg']

      if (file.size > 10000000 * 10 || !ALLOW_FILE.includes(file.type)) {
        return true
      }

      return false
    },
    onPaymentMethodChange(value) {
      this.model.bank_name = null
      this.model.account_number = null
      this.model.account_name = null
    },
    bankNameChange() {
      this.model.account_number = null
      this.model.account_name = null
    },
    accountChange(value, opt) {
      this.model.account_name = opt.data.props.name
    },
    onChangeExpenseType(value) {
      switch (this.model.expense_type) {
        case 0:
          this.model.expense_status = 2
          break;
        case 1:
          this.model.expense_status = 3
          break;
        case 2:
          this.model.expense_status = 4
          break;
        default:
          this.model.expense_status = 1
          break;
      }
      this.model.advance_id = undefined
      this.model.advance_amount = null
      this.model.advance_status = undefined
    }
  },
  watch: {
    validate: function (error) {
      this.errors = new Errors(error.errors)
    }
  }
}
</script>
<style>
.ant-calendar-picker-input {
  height: 32px !important;
}
</style>
